import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('userDetailsEditCard');

    return {
        TITLE: t('title')
    };
};

export default useTranslation;
